import React, { useEffect, useMemo } from 'react';
import { useForm, useFormState } from 'react-final-form';

import QCXSelectClienteAutocomplete from '../final-select-cliente-field/QCXSelectClienteAutocomplete';
import QCXSelectDespachanteAutocomplete from '../select-despachante/QCXSelectDespachanteAutocomplete';
import QCXSelectAgenteTransportadorAutocomplete from '../select-transportador-internacional/QCXSelectAgenteTransportadorAutocomplete';

const TIPO_NOTIFY = {
  CLIENTE: 'CLIENTE',
  AGENTE: 'AGENTE',
  DESPACHANTE: 'DESPACHANTE',
};

export default function QCXFinalSelectNotifyAutocomplete({
  label = 'Notify',
  name = 'notifyId',
  tipoNotifyField = 'tipoNotify',
  initialValues,
  disabled,
  required,
  clienteIdForDespachante = null, 
  aereoOnlyAgente = true,
  ...restProps
}) {
  const form = useForm();
  const { values } = useFormState();

  const tipoNotify = values?.[tipoNotifyField];

  useEffect(() => {
    if (values?.[name]) {
      form.change(name, null);
    }
  }, [tipoNotify]);

  const effectiveLabel = useMemo(() => {
    if (tipoNotify === TIPO_NOTIFY.CLIENTE) return label || 'Notify (Cliente)';
    if (tipoNotify === TIPO_NOTIFY.DESPACHANTE) return label || 'Notify (Despachante)';
    if (tipoNotify === TIPO_NOTIFY.AGENTE) return label || 'Notify (Agente)';
    return label || 'Notify';
  }, [tipoNotify, label]);

  if (!tipoNotify) return null;

  if (tipoNotify === TIPO_NOTIFY.CLIENTE) {
    return (
      <QCXSelectClienteAutocomplete
        label={effectiveLabel}
        name={name}
        initialValues={values}
        disabled={disabled}
        required={required}
        {...restProps}
      />
    );
  }

  if (tipoNotify === TIPO_NOTIFY.DESPACHANTE) {
    return (
      <QCXSelectDespachanteAutocomplete
        label={effectiveLabel}
        name={name}
        initialValues={values}
        clienteId={clienteIdForDespachante}
        disabled={disabled}
        required={required}
        {...restProps}
      />
    );
  }

  // AGENTE
  return (
    <QCXSelectAgenteTransportadorAutocomplete
      label={effectiveLabel}
      name={name}
      initialValues={values}
      aereoOnly={aereoOnlyAgente}
      disabled={disabled}
      required={required}
      {...restProps}
    />
  );
}
